import { Button, Card, Drawer, Icon, Input, Table } from 'antd';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { notificacao } from '../master-page/redux/notificacao';
import FormRegistro from './FormRegistro';
import * as actions from './redux/actions';

export class Listar extends Component {
  static propTypes = {
    pessoas: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    drawerVisible: false,
    searchText: '',
  };

  componentDidMount = () => {
    // this.props.actions.buscarAtivos();
    this.props.actions.listar({ order: "NomeCompleto ASC", include: ['UsuarioPerfil', 'UsuarioStatus']});
  };

  showDrawerEditar = registro => {
    this.props.actions.buscarPorId(registro.Codigo, action => {
      if (action === 'PESSOAS_BUSCAR_POR_ID_SUCCESS') {
        this.setState({ drawerVisible: true });
      }
    });
  };
  handleEditarSubmit = form => {
    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      }
      this.salvarRegistro({ ...this.props.pessoas.registro, ...values });
    });
  }
  salvarRegistro = (registro) => {
    this.props.actions.editar(registro, (action) => {
      if(action === 'PESSOAS_EDITAR_SUCCESS'){
        notificacao('success', 'Registro Salvo');
        this.props.actions.listar({ order: "NomeCompleto ASC", include: ['UsuarioPerfil', 'UsuarioStatus']});
        this.setState({ drawerVisible: false });
      } else {
        notificacao('error', 'Falha ao salvar registro');
      }
    });
  };

  handleCancelarDrawer = () => {
    this.setState({ drawerVisible: false });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { this.searchInput = node; }}
          placeholder={``}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Pesquisar
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Limpar
        </Button>
      </div>
    ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
  });
  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  }

  render() {
    const { pessoas } = this.props;
    const colunas = [
      {
        title: 'Nome',
        dataIndex: 'NomeCompleto',
        key: 'NomeCompleto',
        ...this.getColumnSearchProps('NomeCompleto')
      },
      {
        title: 'Email',
        dataIndex: 'Email',
        key: 'Email',
        ...this.getColumnSearchProps('Email')
      },
      {
        title: 'Perfil',
        dataIndex: 'UsuarioPerfil.Descricao',
        key: 'UsuarioPerfil.Descricao',
      },
      {
        title: 'Status',
        dataIndex: 'UsuarioStatus.Nome',
        key: 'UsuarioStatus.Nome',
      },
      {
        title: '',
        dataIndex: '',
        key: 'x',
        render: (text, record) => (
          <span>
            <Button size="small" onClick={() => this.showDrawerEditar(record)}>
              Editar
            </Button>
          </span>
        ),
      },
    ];

    return (
      <div className="pessoas-listar">
        <Drawer
          visible={this.state.drawerVisible}
          width={600}
          placement="right"
          closable
          onClose={() => {
            this.setState({ drawerVisible: false });
          }}
        >
          <FormRegistro submitForm={this.handleEditarSubmit} formRef={el => (this.formRef = el)} />
          <Button onClick={this.handleCancelarDrawer} type="primary" icon="rollback" size="default">
            Cancelar
          </Button>{' '}
          <Button
            onClick={() => this.formRef.props.onSubmit()}
            type="primary"
            icon="save"
            loading={pessoas.editarPending}
          >
            Salvar
          </Button>
        </Drawer>
        <Card title={<h2>Lista de Usuários</h2>}>
          <Table
            dataSource={pessoas.registros}
            columns={colunas}
            rowKey={record => record.Codigo}
            loading={pessoas.listarPending}
            size="small"
            style={{ marginTop: '15pt' }}
          />
        </Card>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pessoas: state.pessoas,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Listar);



// WEBPACK FOOTER //
// ./src/features/pessoas/Listar.js